import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=05144123&scoped=true&functional=true&"
var script = {}
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=05144123&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "05144123",
  null
  
)

export default component.exports